//All sliders must have .basicSlider in the classes of the div that wraps the slides and the arrows.
const basicSlider = document.querySelectorAll('.basicSlider');

//Check if .basicSlider exists
if (basicSlider) {
  basicSlider.forEach(function (slider) {
    //get the arrows wrapper class
    let arrows = slider.querySelector('.arrows');
    //check if arrows exist
    if (arrows) {
      //get the left arrow
      let left = arrows.querySelector('.left');

      //get the right arrow
      let right = arrows.querySelector('.right');

      //get the slides wrapper class
      let slides = slider.querySelector('.slides');

      //When right arrow is clicked run this
      right.addEventListener('click', function () {
        //Move first div in .slides to the end of the .slides wrapper
        slides.appendChild(slides.firstElementChild);
      });

      //When left arrow is clicked run this
      left.addEventListener('click', function () {
        //Move last div in .slides to the start of the .slides wrapper
        slides.prepend(slides.lastElementChild);
      });
    }
  });
}
